import React from 'react';
import { Globe2 } from 'lucide-react';
import { useNetworkPeers } from '../../hooks/useNetworkPeers';
import SpinningGlobe from './SpinningGlobe';

export default function NodesMapSection() {
  const { peers, loading } = useNetworkPeers();

  const cityCount = new Set(peers.filter(p => p.city).map(p => p.city)).size;

  return (
    <section id="network-map" className="py-12 md:py-20 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <Globe2 className="h-6 w-6 text-green-500" />
              <h2 className="text-2xl md:text-3xl font-bold">Global Node Network</h2>
            </div>
            <p className="text-gray-400 max-w-xl">
              Real-time view of {loading ? '—' : peers.length} peers across{' '}
              {loading ? '—' : cityCount} cities.
            </p>
          </div>
        </div>

        {loading ? (
          <div
            style={{
              position: 'relative',
              background: 'rgba(15,23,42,0.3)',
              borderRadius: 40,
              overflow: 'hidden',
              minHeight: 500,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div className="w-8 h-8 border-2 border-green-500/30 border-t-green-500 rounded-full animate-spin" />
          </div>
        ) : (
          <SpinningGlobe peers={peers} />
        )}
      </div>
    </section>
  );
}
